import {Dropdown} from "rsuite";
import React, {useEffect, useMemo, useState} from "react";
import {setWarehouse} from "../../slices/warehouseSlise";
import {useTranslation} from "react-i18next";
import {useAppDispatch, useAppSelector} from "../../hooks";

import './Warehouse.sass'
import {IWarehouse} from "../../interfaces/Warehouse";

const Warehouse: React.FC<{ handleWarehouse?: Function, hideAll?: boolean }> = ({ handleWarehouse, hideAll = false }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const defaultWarehouseId = useAppSelector(state => state.user.value.defaultWarehouseId);
    const { defaultWarehouse, warehousesList } = useAppSelector(state => state.warehouse.value);

    const [selectedWarehouse, setSelectedWarehouse] = useState<IWarehouse | null>(null);

    useEffect(() => {
        if (!warehousesList || warehousesList.length === 0) return;

        let warehouse = warehousesList.filter(w => !hideAll || w.id != 0).find(w => w.id === defaultWarehouse) ?? null;

        if (!warehouse && defaultWarehouseId != null) {
            warehouse = warehousesList.filter(w => !hideAll || w.id != 0).find(w => w.id === defaultWarehouseId) ?? null;
        }

        if (!warehouse && !hideAll) {
            warehouse = warehousesList.find(w => w.id === 0) ?? null;
        }

        console.log(warehousesList);
        console.log(warehouse, defaultWarehouse, defaultWarehouseId);

        setSelectedWarehouse(warehouse);

        if (warehouse && warehouse.id !== defaultWarehouse) {
            dispatch(setWarehouse(warehouse.id));
            handleWarehouse?.(warehouse.id);
        }
    }, [warehousesList, defaultWarehouse, defaultWarehouseId, dispatch, handleWarehouse]);

    const handleWarehouseSelect = (warehouse: IWarehouse) => {
        setSelectedWarehouse(warehouse);
        dispatch(setWarehouse(warehouse.id));
        handleWarehouse?.(warehouse.id);
    };

    return (
        <div className="warehouse-wrapper">
            {t('wherahouse')} :
            <Dropdown placement={'bottomEnd'} title={selectedWarehouse?.name ?? '---'}>
                {warehousesList.filter(w => !hideAll || w.id != 0).map((warehouse) => (
                    <Dropdown.Item
                        key={warehouse.id}
                        onSelect={() => handleWarehouseSelect(warehouse)}
                    >
                        {warehouse.name}
                    </Dropdown.Item>
                ))}
            </Dropdown>
        </div>
    );
};

export default Warehouse;
